import useResizeScreen from 'hooks/useResizeScreen'
import { useDispatch, useSelector } from 'react-redux'
import { getIsMobileTraffic } from 'selectors/shared/mobileTraffic'
import { Actions as ScreenActions } from 'actions/screen'
import { Screen } from 'types/Screen'

const ScreenComponent = () => {
  const isMobile = useSelector(getIsMobileTraffic)
  const dispatch = useDispatch()
  const updateScreenSize = (payload: Screen) => {
    dispatch(ScreenActions.UPDATE_SCREEN_SIZE(payload))
  }

  useResizeScreen({
    callback: updateScreenSize,
    delay: 250,
    isMobile,
  })
  return null
}

export default ScreenComponent
